import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Fonts ship with the app: the Discord Activity cannot load Google Fonts.
import '@fontsource/golos-text/400.css'
import '@fontsource/golos-text/500.css'
import '@fontsource/golos-text/600.css'
import '@fontsource/unbounded/500.css'
import '@fontsource/unbounded/700.css'
import { App } from './App'
import './styles.css'
import { DialogHost } from './ui/Dialog'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <DialogHost />
  </StrictMode>,
)
